import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRoute, faMoneyBillWave, faMotorcycle,
  faFileAlt, faHeadset, faWallet
} from '@fortawesome/free-solid-svg-icons';

export const AdminKpiHeader = ({ kpis, onNavigate }) => {
  const cards = [
    {
      title: 'Viajes Hoy',
      value: kpis.tripsToday || 0,
      icon: faRoute,
      color: 'var(--bry-accent, #0EABB0)',
      subtitle: 'Completados',
      action: () => onNavigate?.('/admin/servicios')
    },
    {
      title: 'Recaudación Hoy',
      value: `$${(kpis.earningsToday || 0).toFixed(2)}`,
      icon: faMoneyBillWave,
      color: 'var(--bry-accent, #0EABB0)',
      subtitle: `Comisiones: $${(kpis.commissionToday || 0).toFixed(2)}`,
      action: () => onNavigate?.('/admin/ganancias')
    },
    {
      title: 'Saldo Billeteras',
      value: `$${(kpis.walletTotalBalance || 0).toFixed(2)}`,
      icon: faWallet,
      color: '#4ade80',
      subtitle: `${kpis.walletsWithBalanceCount || 0} billetera(s) con saldo`,
      action: () => onNavigate?.('/admin/conductores')
    },
    {
      title: 'Conductores Activos',
      value: kpis.activeDrivers || 0,
      icon: faMotorcycle,
      color: 'var(--bry-accent, #0EABB0)',
      subtitle: 'Verificados',
      action: () => onNavigate?.('/admin/conductores')
    },
    {
      title: 'Documentos Pendientes',
      value: kpis.pendingDocs || 0,
      icon: faFileAlt,
      color: kpis.pendingDocs > 0 ? '#F59E0B' : 'var(--bry-accent, #0EABB0)',
      subtitle: 'Requieren revisión',
      action: () => onNavigate?.('/admin/documentos')
    },
    {
      title: 'Tickets de Soporte',
      value: kpis.openTickets || 0,
      icon: faHeadset,
      color: kpis.openTickets > 0 ? '#EF4444' : 'var(--bry-accent, #0EABB0)',
      subtitle: 'Abiertos / En proceso',
      action: () => onNavigate?.('/soporte')
    }
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((card, idx) => (
        <div key={idx} className="col-12 col-sm-6 col-lg">
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: idx * 0.05 }}
            whileHover={{ y: -3 }}
            onClick={card.action}
            className="p-3 rounded-4 position-relative overflow-hidden h-100"
            style={{
              backgroundColor: 'rgba(20, 20, 20, 0.95)',
              border: '1px solid rgba(14, 171, 176, 0.25)',
              cursor: 'pointer',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="text-white-50 extra-small fw-bold text-uppercase tracking-wider">{card.title}</span>
              <div
                className="rounded-3 d-flex align-items-center justify-content-center"
                style={{
                  width: '36px',
                  height: '36px',
                  backgroundColor: 'rgba(14, 171, 176, 0.12)',
                  color: card.color
                }}
              >
                <FontAwesomeIcon icon={card.icon} size="lg" />
              </div>
            </div>

            <h3 className="text-white fw-extrabold mb-1">{card.value}</h3>
            <span className="text-white-50 extra-small">{card.subtitle}</span>
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export default AdminKpiHeader;
